import { CRM_SYSTEM_ID, PROTAL_URL_ENUM } from './config';
import { instance } from './store';
import merge from 'lodash/merge';
import omit from 'lodash/omit';
import { getUserData } from './user';
import { logger } from './logger';
import { pluginsMap } from './plugins';

import type { CRMOptions, InnerOptions, KContext } from './types';

export async function transformCRMOptions(options: CRMOptions): Promise<InnerOptions> {
  const store = instance.getAll();

  /** 是否是主应用 */
  const isMain = !instance.isExist();

  /** 是否是门户业务线 */
  const isPortalBiz =
    typeof options?.microApp === 'object' &&
    typeof options.microApp?.parentProps?.createParamsConfig === 'function' &&
    typeof options.microApp?.parentProps?.name === 'string' &&
    options.microApp.parentProps.createParamsConfig(options.microApp.parentProps.name)
      ?.enabledMenu === 1
      ? true
      : false;

  /** 当前的系统名称 */
  const currentSubSystemName = isMain ? options?.subSystemName : store.currentSubSystemName;

  /** 当前的环境变量 */
  const env = options?.env || store?.env;

  /** 当前网关前缀 */
  const gatewayUrl = options?.gatewayUrl || store?.gatewayUrl || PROTAL_URL_ENUM[env] || '';

  /** 页面来源 */
  const source = store?.source || 'unknown';

  /** 当前用户信息 */
  const userData =
    options?.userData ||
    store?.userData ||
    (await getUserData({
      axios: options?.axios,
      subSystemName: currentSubSystemName,
      source,
      gatewayUrl,
    }));

  /** 默认执行的插件列表 */
  const plugins = options.reflush
    ? {}
    : {
        upm: true,
        lcdp: true,
        micro: isPortalBiz,
      };

  const result = merge(
    { systemId: CRM_SYSTEM_ID, logger: true, ...plugins },
    {
      ...options,
      isMain,
      env,
      gatewayUrl,
      userData,
      currentSubSystemName,
      source,
      isPortalBiz,
    }
  );

  /** 记录日志 */
  logger.push('基础信息参数', omit({ ...result }, Object.keys(pluginsMap)));
  return result;
}

export function transformAxiosOption(context: KContext, options: CRMOptions) {
  const { axios } = context?.['app']?.['__selfModule__'] || {};
  options.axios =
    typeof options.axios === 'object' ? { instance: axios, ...options.axios } : { instance: axios };
  return options;
}
